/*
 *
 * EasySplit constants
 *
 */
export const BASE_ACTION_CONSTANT = 'app/EasySplit';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const REQUEST_ACTIVATION = `${BASE_ACTION_CONSTANT}/REQUEST_ACTIVATION`;

export const EMBED_MODAL = 'EMBED_MODAL';

export const EASY_SPLIT_STATUS = {
  ACTIVE: 'ACTIVE',
  HOLD: 'HOLD',
  NOT_ACTIVE: 'NOT_ACTIVE',
  REQUESTED: 'REQUESTED',
};

export const REQUEST_ACTIVATION_PAYLOAD = {
  status: EASY_SPLIT_STATUS.ACTIVE,
  adminId: '507',
  // scheduleId: 1,
  // orderSplitAfterPaymentEnabled: true,
  // orderSplitMaxDelayInDays: 1,
};

export const PITCH_PAGE_DESCRIPTION = [
  {
    title: 'Add Vendor Accounts',
    content:
      'Add vendor details and define the settlement cycle for the vendor.',
  },
  {
    title: 'Collect & Split Payments',
    content:
      'Collect payments using our Cashfree payments products. Specify the split details and Easy Split will automatically initiate payment splits to vendor accounts.',
  },
  {
    title: 'Manage Settlements ',
    content:
      "Settlements will be processed as per the defined settlement cycle. Refunds, discounts, or adjustments will be considered prior to settlement in the vendor's bank account.",
  },
];

export const EASY_SPLIT_VIDEO_LINK =
  'https://www.youtube.com/embed/7gWk996tLM4';

export const EASY_SPLIT_KNOW_MORE_LINK =
  'https://docs.cashfree.com/docs/easy-split-features';

export const CRITICAL_BUSINESS = [
  'Insurance',
  'Mutual funds/Broking',
  'NBFCs / Organizations into Lending',
];

export const BUSINESS_TYPE_MAPPING = {
  1: 'Education',
  2: 'Government',
  3: 'Insurance',
  4: 'Jewellery',
  5: 'Gemstone/Diamond',
  6: 'Mutual funds/Broking',
  7: 'NBFCs / Organizations into Lending',
  8: 'Non Profit / NGO',
  9: 'Online Gaming',
  10: 'Open/Partial Open Wallet',
  11: 'Pharmacy',
  12: 'Travel and Hospitality',
  13: 'Utilities',
  14: 'Aggregators',
  15: 'Hemp Products / Herbal Products',
  16: 'FOREX',
  17: 'Chit Funds',
  18: 'Web host/Domain seller',
  19: 'Professional services(Doctors, Lawyers, Architects, CAs and other Professionals)',
  20: 'Food Industry',
  21: 'International Card Acceptance (Goods export)',
};

export const DOCS_ADDRESS_MAPPING = {
  1: ['UIDAI_FRONT', 'UIDAI_BACK'],
  2: ['DL'],
  3: ['VOTER_ID'],
  4: ['PASSPORT_FRONT', 'PASSPORT_BACK'],
};

export const DOC_VALUES_ON_ADDRESS = [
  ['UIDAI_FRONT', 'UIDAI_BACK'],
  ['DL'],
  ['VOTER_ID'],
  ['PASSPORT_FRONT', 'PASSPORT_BACK'],
];

export const POSSIBLE_KYC_PAYLOAD = [
  'pan',
  'uidai',
  'passport',
  'drivingLicense',
  'voterId',
  'gst',
  'cin',
  'completeFileObj',
];

export const POSSIBLE_BUSINESS_FIELDS = ['gst', 'cin'];

export const POSSIBLE_INDIVIDUAL_FIELDS = [
  'uidai',
  'drivingLicense',
  'voterId',
  'passport',
];

export const RELATED_DOCS_INPUT_MAPPING = {
  PASSPORT_NUMBER: 'passport',
  UIDAI_NUMBER: 'uidai',
  DL_NUMBER: 'drivingLicense',
  VOTER_ID_NUMBER: 'voterId',
  GSTIN_NUMBER: 'gst',
  CIN_NUMBER: 'cin',
};

export const POSSIBLE_KYC_DOCS = [
  'UIDAI_FRONT',
  'UIDAI_BACK',
  'DL',
  'PASSPORT_FRONT',
  'PASSPORT_BACK',
  'VOTER_ID',
  'GST',
  'CIN',
  'NBFC_CERTIFICATE',
];

export const ADDRESS_DOCS_API_RESPONSE = [
  'UIDAI_NUMBER',
  'DL_NUMBER',
  'VOTER_ID_NUMBER',
  'PASSPORT_NUMBER',
];

export const GENERAL_FILE_CHECKLIST = [
  ' Max file size: 25 MB',
  ' File format: .png, .jpeg, .pdf, .jpg',
];

export const PASSPORT_FRONT_CHECKLIST = [
  ' Max file size: 25 MB',
  ' File format: .png, .jpeg, .pdf, .jpg',
  ' Upload first two pages',
];

export const PASSPORT_BACK_CHECKLIST = [
  ' Max file size: 25 MB',
  ' File format: .png, .jpeg, .pdf, .jpg',
  ' Upload last two pages',
];

export const DRIVING_LICENSE_CHECKLIST = [
  ' Max file size: 25 MB',
  ' File format: .png, .jpeg, .pdf, .jpg',
  ' Upload the side that has the photo and the details. If both sides have the details, upload them in a single document',
];

export const VOTER_ID_CHECKLIST = [
  ' Max file size: 25 MB',
  ' File format: .png, .jpeg, .pdf, .jpg',
  ' Upload front side of the voter ID',
];

export const VALID_FILE_FORMATS = '.png,.jpeg,.pdf,.jpg';

export const POSSIBLE_BUSINESS_DOCS = ['businessPanDoc', 'GST', 'CIN'];

export const POSSIBLE_INDIVIDUAL_DOCS = [
  'PAN',
  'UIDAI_FRONT',
  'UIDAI_BACK',
  'PASSPORT_FRONT',
  'PASSPORT_BACK',
  'DL',
  'VOTER_ID',
];

export const BUSINESS_TYPE_OPTION = [
  { value: 1, text: 'Education' },
  { value: 2, text: 'Government' },
  { value: 3, text: 'Insurance' },
  { value: 4, text: 'Jewellery' },
  { value: 5, text: 'Gemstone/Diamond' },
  { value: 6, text: 'Mutual funds/Broking' },
  { value: 7, text: 'NBFCs / Organizations into Lending' },
  { value: 8, text: 'Non Profit / NGO' },
  { value: 9, text: 'Online Gaming' },
  { value: 10, text: 'Open/Partial Open Wallet' },
  { value: 11, text: 'Pharmacy' },
  { value: 12, text: 'Travel and Hospitality' },
  { value: 13, text: 'Utilities' },
  { value: 14, text: 'Aggregators' },
  { value: 15, text: 'Hemp Products / Herbal Products' },
  { value: 16, text: 'FOREX' },
  { value: 17, text: 'Chit Funds' },
  { value: 18, text: 'Web host/Domain seller' },
  {
    value: 19,
    text:
      'Professional services(Doctors, Lawyers, Architects, CAs and other Professionals)',
  },
  { value: 20, text: 'Food Industry' },
  { value: 21, text: 'International Card Acceptance (Goods export)' },
];

export const ADDRESS_PROOF_OPTIONS = [
  {
    key: 1,
    value: 1,
    text: 'Aadhaar',
  },
  {
    key: 2,
    value: 2,
    text: 'Driving License',
  },
  {
    key: 3,
    value: 3,
    text: 'Voter ID',
  },
  {
    key: 4,
    value: 4,
    text: 'Passport',
  },
];

export const VENDOR_TYPE_RADIO_DATA = {
  radioOptions: [
    {
      label: 'Business Entity',
      name: 'accountType',
      value: 'BUSINESS',
    },
    {
      label: 'Individual',
      name: 'accountType',
      value: 'INDIVIDUAL',
    },
  ],
};

export const RENDER_BUSINESS_FORM = [
  {
    input: {
      id: 'businessPan',
      name: 'businessPan',
      label: 'Business PAN',
    },
    text: 'Upload Business PAN',
    docs: {
      id: 'businessPanDoc',
      name: 'businessPanDoc',
      checkList: GENERAL_FILE_CHECKLIST,
    },
  },
  {
    input: {
      id: 'gst',
      name: 'gst',
      label: 'GST Number',
    },
    text: 'Upload GST Certificate',
    docs: {
      id: 'GST',
      name: 'GST',
      checkList: GENERAL_FILE_CHECKLIST,
    },
  },
  {
    input: {
      id: 'cin',
      name: 'cin',
      label: 'CIN Number',
    },
    text: 'Upload CIN Certificate',
    docs: {
      id: 'CIN',
      name: 'CIN',
      checkList: GENERAL_FILE_CHECKLIST,
    },
  },
];

export const RENDER_INDIVIDUAL_FORM = [
  {
    addressProof: 1,
    input: {
      id: 'uidai',
      name: 'uidai',
      label: 'Aadhaar Number',
    },
    docs: [
      {
        id: 'UIDAI_FRONT',
        name: 'UIDAI_FRONT',
        text: 'FrontSide of Aadhaar',
        checkList: GENERAL_FILE_CHECKLIST,
      },
      {
        id: 'UIDAI_BACK',
        name: 'UIDAI_BACK',
        text: 'BackSide of Aadhaar',
        checkList: GENERAL_FILE_CHECKLIST,
      },
    ],
  },
  {
    addressProof: 2,
    input: {
      id: 'drivingLicense',
      name: 'drivingLicense',
      label: 'Driving License Number',
    },
    docs: [
      {
        id: 'DL',
        name: 'DL',
        text: 'Upload Driving License',
        checkList: DRIVING_LICENSE_CHECKLIST,
      },
    ],
  },
  {
    addressProof: 3,
    input: {
      id: 'voterId',
      name: 'voterId',
      label: 'Voter ID Number',
    },
    docs: [
      {
        id: 'VOTER_ID',
        name: 'VOTER_ID',
        text: 'Upload Voter ID',
        checkList: VOTER_ID_CHECKLIST,
      },
    ],
  },
  {
    addressProof: 4,
    input: {
      id: 'passport',
      name: 'passport',
      label: 'Passport Number',
    },
    docs: [
      {
        id: 'PASSPORT_FRONT',
        name: 'PASSPORT_FRONT',
        text: 'FrontSide of Passport',
        checkList: PASSPORT_FRONT_CHECKLIST,
      },
      {
        id: 'PASSPORT_BACK',
        name: 'PASSPORT_BACK',
        text: 'BackSide of Passport',
        checkList: PASSPORT_BACK_CHECKLIST,
      },
    ],
  },
];
export const INDIVIDUAL = 'INDIVIDUAL';

export const BUSINESS = 'BUSINESS';

export const PAN = 'PAN';

export const NBFC_CERTIFICATE = 'NBFC_CERTIFICATE';

export const NBFC_TEXT = 'NBFCs / Organizations into Lending';

export const PAN_NUMBER = 'PAN_NUMBER';

export const PAN_NAME = 'pan';

export const BUSINESS_PAN = 'businessPan';

export const BUSINESS_PAN_DOC = 'businessPanDoc';

export const FILE_SIZE = 25;

export const KYC_VALIDATION_REQUIRED_MSG = 'This is a required field';

export const IN_KYC_REVIEW = 'IN_KYC_REVIEW';

export const IN_REVIEW = 'IN_REVIEW';

export const SAMPLE_REGEX_INPUT_MAPPING = {
  pan: 'BNZAA2318J',
  uidai: '367598346012',
  passport: 'A2096457',
  drivingLicense: 'HR0619850034761',
  voterId: 'XGN3002623',
  gst: '06BZAHM6385P6Z2',
  cin: 'U12345AB6784CDE123456',
  businessPan: 'BNZAA2318J',
};
export const EASY_SPLIT_SETTLEMENTS = 'Easy-Split Settlements';
